import React, { useState, useEffect } from 'react';
import PlaylistRow from './PlaylistRow';
import HeroSection from '../common/HeroSection';
import { mountIsland } from '../../mountIsland';


const Home = ({ defaultResults }) => {

const features = Array.isArray(defaultResults.features)
  ? defaultResults.features
  : [];

const getFeaturedVideos = () => {
  let firstValidfeature = features.find(p => Array.isArray(p.videos) && p.videos.length > 0);
  return firstValidfeature ? firstValidfeature.videos.slice(0, 4) : [];
};

  const featuredVideos = getFeaturedVideos();

  return (
    <>
      <div className="home-overlay"></div>

      <div className="home-wrapper">
        <div className="home-hero">
          <div className="home-hero-overlay"></div>

          {featuredVideos.length > 0 && (
            <div className="home-hero-content">
              <HeroSection
                featuredVideos={featuredVideos}
                isLoggedIn={defaultResults.logged_in_user === true}
              />
            </div>
          )}
        </div>

        <div className="home-features">
{features.length > 0 ? (
  <>
    {features.map((feature, index) => {
      const props = {
        title: feature.name,
        url: feature.is_custom ? (feature.parent_links?.web || feature.permalinks?.web) : (feature.permalinks?.web || '/app/twi/results?' + (feature.group_type === 'type' ? `type=${encodeURIComponent(feature.result_parameter)}` : `category=${encodeURIComponent(feature.result_parameter)}`)),
        // NB: do not replace with feature.permalinks?.api — that field points to the
        // results/playlists navigation endpoint, not the playlist_block fragment endpoint
        // PlaylistRow needs for lazy-loading (&offset/&limit). Different shape + params.
        fetchUrl: `/api/v2/twi/playlist_block?type=${feature.group_type}&tag=${encodeURIComponent(feature.result_parameter)}`,
        filters: feature.filters || {}
      };
     return <PlaylistRow
        key={index}
        {...props}
        initialVideos={feature.videos}
      />;
    })}
  </>
) : (
  <div className="home-empty-state">
    <svg
      xmlns="http://www.w3.org/2000/svg"
      className="home-empty-icon"
      fill="none"
      viewBox="0 0 24 24"
      stroke="currentColor"
    >
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={1.5}
        d="M7 4v16M17 4v16M3 8h18M3 16h18"
      />
    </svg>
    <p className="home-empty-text">No features available at the moment.</p>
    <p className="home-empty-subtext">Check back later for new content.</p>
  </div>
)}



        </div>
      </div>
    </>
  );
};

const container = document.getElementById('videos-home-container');
if (container) {
  let results = { features: [], logged_in_user: false };

  try {
    const rawData = container.getAttribute('data-groups');
    if (rawData) {
      const parsed = JSON.parse(rawData);
      results = {
        ...parsed,
        logged_in_user: parsed.logged_in_user === true,
      };
    }
  } catch (e) {
    console.error('Error parsing features JSON:', e);
  }
  mountIsland(container, <Home defaultResults={results} />);
}

export default Home;
